// A loud, always-on indicator that this is NOT the production deployment.
//
// Prod and dev are served from the SAME static bundle (NODE_ENV=production
// on both), so a build-time flag would be fragile and easy to forget. The
// one thing that genuinely differs at runtime is the host: prod lives at
// PROD_HOST, dev at johndo-dev.cartonlab.nz. We therefore hide the banner
// ONLY on the exact prod host and show it everywhere else (dev host,
// localhost, LAN IPs) — fail-safe: a misconfigured/unknown host shows the
// banner rather than masquerading as prod.
//
// Everything here is pointer-events-none so the loud chrome never
// intercepts clicks on the UI beneath it.

const PROD_HOST = "johndo.cartonlab.nz";

// Calming blue gradient that drifts side to side (see .animate-dev-wave).
const WAVE =
  "linear-gradient(120deg, #2563eb 0%, #38bdf8 35%, #60a5fa 50%, #38bdf8 65%, #2563eb 100%)";

export function DevBanner() {
  const host =
    typeof window === "undefined" ? "" : window.location.hostname;
  if (host === PROD_HOST) return null;

  return (
    <>
      {/* Calming-blue wave bar pinned to the very top, full width. */}
      <div
        role="status"
        aria-label="Development environment"
        className="animate-dev-wave pointer-events-none fixed inset-x-0 top-0 z-[100] flex h-7 items-center justify-center overflow-hidden"
        style={{ background: WAVE }}
      >
        <span className="rounded-full bg-white/20 px-3 py-0.5 text-xs font-semibold uppercase tracking-[0.2em] text-white shadow-sm backdrop-blur-sm">
          Dev — {host}
        </span>
      </div>

      {/* Soft blue frame around the whole viewport, gently pulsing, so the
          warning is present no matter where you've scrolled. */}
      <div
        aria-hidden
        className="animate-dev-frame pointer-events-none fixed inset-0 z-[99] border-4 border-sky-400"
      />
    </>
  );
}
